export const openInNewTab = (url: string) => {
    const link = Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: url,
    });
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};